export enum BlockchainNotificationType {
  TxUpdated = 'TxUpdated',
  DraftDocCreated = 'DraftDocCreated',
  DocPublished = 'DocPublished',
  DocApproved = 'DocApproved',
}

